import React from 'react'
import TableCell from 'uiKit/table/TableCell'

const getText = (children: React.ReactNode): string => React.Children.toArray(children).map(child => {
  if (typeof child === 'string' || typeof child === 'number') return String(child)
  if (!React.isValidElement(child)) return ''
  if (child.props.labels) return child.props.labels.join(', ')
  return getText(child.props.children)
}).join('')

const DashboardTableCell: React.FC<{ style?: React.CSSProperties }> = ({ children, style }) => (
  <TableCell style={{ ...style, minWidth: 0 }}>
    <span
      title={getText(children)}
      style={{
        display: '-webkit-box',
        WebkitBoxOrient: 'vertical',
        WebkitLineClamp: 2,
        width: '100%',
        minWidth: 0,
        maxHeight: 40,
        lineHeight: '20px',
        overflow: 'hidden',
        overflowWrap: 'anywhere',
        wordBreak: 'normal',
      }}>
      {children}
    </span>
  </TableCell>
)

export default DashboardTableCell
